// extracted by mini-css-extract-plugin
export var page = "article_list-module--page--33QV-";
export var articles = "article_list-module--articles--2fExn";
export var article = "article_list-module--article--2Z1WR";
export var nav = "article_list-module--nav--gDp2a";